<script setup lang="ts">
  interface Props {
    example: string;
  }

  defineProps<Props>();
</script>

<template>
  <div class="bg-gray-02 rounded-xl p-4 w-fit">
    <p class="font-medium">
      {{ example }}
    </p>
  </div>
</template>
